import React from "react";
import AuthedRoutes from "./Routes/AuthedRoutes";
import UnAuthedRoutes from "./Routes/UnAuthedRoutes";

export default ({ token }) => (token ? <AuthedRoutes /> : <UnAuthedRoutes />);
